import {getParameterByName} from '../helpers/get-parameter-by-name';
import {Scroll} from '../helpers/scroll';

export class ScrollToParam {
	constructor(parameter) {
		const parameterValue = getParameterByName(parameter);

		if(parameterValue) {
			this.scrollToCurrent(parameterValue);
		}
	}

	scrollToCurrent(currentId) {
		const element = document.getElementById(currentId);
		if(element){
			Scroll.scrollPageTo(element, 500, 134);
		}
	}
}
